import React, { useState } from "react";

import Button from "../Button/Button";

import styles from "./MainContent.module.css";

const MainContent = ({
  handleOpenOverlay,
  handleToggleVideo,
}: {
  handleOpenOverlay: () => void;
  handleToggleVideo: () => void;
}) => {
  const [isKnowMoreOpen, setIsKnowMoreOpen] = useState(false);

  const toggleKnowMore = () => {
    setIsKnowMoreOpen(!isKnowMoreOpen);
  };

  return (
    <main className={styles.main}>
      <div
        className={`${styles.container} ${isKnowMoreOpen ? styles.open : ""}`}
      >
        <figure className={styles.headline}>
          <img
            src="/images/headline.svg"
            alt="Viver com Entusiasmo"
            width={493}
            height={295}
            className={styles.innerHeadline}
          />
        </figure>
        <div className={styles.contentBox}>
          <p>Qual é o seu valor como pessoa?</p>
          <img
            src="/images/equation.svg"
            alt="equação o seu valor como pessoa"
          />
        </div>
        <div className={styles.ctaBlock}>
          {/* <p>
            <span>22 Abril 2025, 19h30</span>
            <br /> Teatro Politeama - Lisboa
          </p> */}
          <div className={styles.buttonContainer}>
            {/* <Button
              label="Registo"
              type="primary"
              handleClick={handleOpenOverlay}
            /> */}
            <Button
              label="Saber Mais"
              type="secondary"
              handleClick={toggleKnowMore}
            />
          </div>
        </div>
        <figure className={styles.image}>
          <img
            src="/images/portrait.jpg"
            alt="Victor Küppers"
            width={573}
            height={727}
            className={styles.innerImage}
          />
          <button className={styles.playButton} onClick={handleToggleVideo}>
            <img src="/images/play.svg" alt="Play" />
          </button>
        </figure>
        {isKnowMoreOpen ? (
          <>
            <div className={styles.knowMore}>
              <p className={styles.knowMoreQuote}>
                Acrescente valor à sua organização e melhore a atitude da sua
                equipa.
              </p>
              <div className={styles.knowMoreText}>
                <p>
                  <strong>Victor Küppers</strong> é um orador nas áreas da
                  motivação e desenvolvimento pessoal. Nas suas palestras,
                  Victor ajuda{" "}
                  <strong>
                    profissionais e equipas a conquistar objetivos, aumentar a
                    produtividade
                  </strong>{" "}
                  e adotar uma mentalidade positiva de sucesso.
                </p>
                <p>
                  A sua missão é ajudar as pessoas a viver com paixão, alegria e
                  entusiasmo e consciencializar os participantes sobre a
                  importância de viver e trabalhar com base em princípios e
                  valores humanos. Com mais de 20 anos de experiência, Victor
                  Küppers colabora habitualmente com grandes empresas
                  multinacionais como Inditex, Nestlé, Repsol, Deloitte, etc.,
                  com o objetivo de melhorar a atitude das pessoas e das equipas
                  de trabalho.
                </p>
              </div>
            </div>
            <p className={styles.quote}>
              “O mais importante na vida é que o mais importante seja o mais
              importante.” <strong>Stephen Covey</strong>
            </p>
          </>
        ) : (
          ""
        )}
      </div>
    </main>
  );
};

export default MainContent;
